import { Url } from '@wix/da-url';
import { getDeviationType, getPrimaryTier, isDeviationAuthor, } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { usePrimaryTier } from '../../Tier/PrimaryTierContext';
import { useCurrentUser } from './useCurrentUser';
/** returns member subscription info for the given deviation */
export function useSubscriptionTier(deviation) {
    var currentUser = useCurrentUser();
    var isOwner = deviation ? isDeviationAuthor(deviation, currentUser) : false;
    var contextualTier = usePrimaryTier();
    var _a = getBasicTierSubscriptionInfo(deviation, contextualTier), isTier = _a.isTier, isInTier = _a.isInTier, tier = _a.tier, isUserSubscribed = _a.isUserSubscribed, tierCheckoutUrl = _a.tierCheckoutUrl, subscriptionsTabUrl = _a.subscriptionsTabUrl, needsSubscription = _a.needsSubscription, isSubscribedButBlocked = _a.isSubscribedButBlocked;
    // you are never blocked if
    // - you're the content's owner,
    // - there's no subscription needed
    var subscriptionsMatter = !isOwner && !isTier;
    return {
        isTier: isTier,
        isInTier: isInTier,
        tier: tier,
        isOwner: isOwner,
        isUserSubscribed: isUserSubscribed,
        tierCheckoutUrl: tierCheckoutUrl,
        subscriptionsTabUrl: subscriptionsTabUrl,
        needsSubscription: subscriptionsMatter && needsSubscription,
        isSubscribedButBlocked: subscriptionsMatter && isSubscribedButBlocked,
    };
}
/**
 * Get the basic tier info without react dependency
 */
export function getBasicTierSubscriptionInfo(deviation, contextualTier) {
    var _a, _b, _c;
    var primaryTierFromDeviation = deviation && getPrimaryTier(deviation);
    var primaryTier = contextualTier || primaryTierFromDeviation;
    var isTier = deviation
        ? getDeviationType(deviation) === DeviationTypes.TIER
        : false;
    var isInTier = !!primaryTier;
    var tier = isTier ? deviation : primaryTier;
    var isUserSubscribed = isTier
        ? !!((_a = deviation === null || deviation === void 0 ? void 0 : deviation.tier) === null || _a === void 0 ? void 0 : _a.isUserSubscribed)
        : !!((_b = primaryTierFromDeviation === null || primaryTierFromDeviation === void 0 ? void 0 : primaryTierFromDeviation.tier) === null || _b === void 0 ? void 0 : _b.isUserSubscribed);
    var tierCheckoutUrl = ((_c = tier === null || tier === void 0 ? void 0 : tier.tier) === null || _c === void 0 ? void 0 : _c.subproductId)
        ? Url.checkoutLink(tier.tier.subproductId)
        : undefined;
    var subscriptionsTabUrl = (tier === null || tier === void 0 ? void 0 : tier.author)
        ? Url.userLink(tier.author.username, '/subscriptions')
        : undefined;
    var needsSubscription = !!tier && !isUserSubscribed;
    var isSubscribedButBlocked = (deviation === null || deviation === void 0 ? void 0 : deviation.tierAccess) === 'locked-subscribed';
    return {
        isTier: isTier,
        isInTier: isInTier,
        tier: tier,
        isUserSubscribed: isUserSubscribed,
        tierCheckoutUrl: tierCheckoutUrl,
        subscriptionsTabUrl: subscriptionsTabUrl,
        needsSubscription: needsSubscription,
        isSubscribedButBlocked: isSubscribedButBlocked,
    };
}
//# sourceMappingURL=useSubscriptionTier.js.map